
import { Component, Prop, Vue} from 'vue-property-decorator';
import { KNOWLEDGE_CHECK_EVENTS as KCE } from '@/author/constants';
import KnowledgeCheckEvents from '@/author/components/KnowledgeCheckParts/KnowledgeCheckEvents.vue';
import { emit } from 'process';

@Component
export default class QuizOption extends Vue {
  @Prop() type?: string;
  @Prop() src?: string;
  @Prop() alt?: string;
  @Prop() right?: boolean;
  @Prop() modal?: boolean;
  isFirstOption: boolean = false;

  correctFeedback!: string;
  incorrectFeedback!: string;
  selectedFeedback!: string;
  instantFeedback: boolean = false;
  showFeedback: boolean = false;
  multiple: boolean = false;
  blockDeselection: boolean = false;
  blockChanges: boolean = false;
  textContent: string = '';

  haveOptionSelected: boolean = false;
  selected: boolean = false;
  answer: boolean = false;
  id: string = '';

  public $refs!: {
    wrapper: HTMLElement;
    button: HTMLElement;
  };

  created(){
    KnowledgeCheckEvents.$on(KCE.AFTER_OPTION_MOUNTED, (multiple:boolean)=>{
      this.multiple = multiple;
    });
    KnowledgeCheckEvents.$on(KCE.HAS_LEARN_MORE_CONTENT, this.setBlockDeselection);
    KnowledgeCheckEvents.$on(KCE.HAS_EVALUATED_ANSWER, this.setBlockChanges);
  }

  beforeMount() {
    let parent : any = this.$parent;
    this.correctFeedback = parent.accessibilityCorrectFeedback;
    this.incorrectFeedback = parent.accessibilityIncorrectFeedback;
    this.selectedFeedback = parent.accessibilitySelectFeedback;
    this.instantFeedback = parent.instantFeedback;
    this.showFeedback = parent.showFeedback;
    KnowledgeCheckEvents.$emit(KCE.OPTION_MOUNTED, this);

    this.answer = this.right !== undefined;
    this.id = (this as any)._uid;
    if(this.instantFeedback)
      this.showFeedback = true;

    KnowledgeCheckEvents.$on(KCE.CLEAR_OPTIONS,() => {
      this.handleClearOptions();
    });
    KnowledgeCheckEvents.$on(KCE.OPTION_SELECTED,() => {
      this.haveOptionSelected = true;
    });
  }

  mounted(){
    const text = this.$refs.wrapper.textContent;
    this.textContent = this.alt ? `${this.alt}`: `${text}`;
    KnowledgeCheckEvents.$emit(KCE.AFTER_OPTION_COMPLETED_MOUNTED, this);
  }

  setBlockChanges() {
    this.blockChanges = true;
  }

  setBlockDeselection() {
    this.blockDeselection = true;
    this.instantFeedback = true;
  }

  handleQuizOptionClick() {
    if (this.blockChanges || (this.selected && this.blockDeselection))
      return;
    if(!this.multiple){
      KnowledgeCheckEvents.$emit(KCE.CLEAR_OPTIONS, this);
      this.selected = true;
    } else 
      this.selected = !this.selected;
    
    this.$refs.wrapper.focus();
    KnowledgeCheckEvents.$emit(KCE.CONTEXT_OPTION_SELECTED, { textContent : `${this.$refs.wrapper.textContent}`} );
    KnowledgeCheckEvents.$emit(KCE.OPTION_SELECTED, this);
  }
  
  handleFocus() {
    if(this.$refs.button) {
      const button = this.$refs.button;
      button.classList.contains('focus') ? button.classList.remove('focus') : button.classList.add('focus');
    };
  }

  handleClearOptions() {
    this.selected = false;
  }
  get hasCustomFeedback():boolean{
    return !!this.$slots['feedback'];
  }

  get slot_id(){
    return `id_${this.id}_slot`;
  }
  handleQuizKeydown(event:KeyboardEvent){
    if(this.multiple) return;

    // Only relevant for radio buttons (single choice questions)
    if(event.key === 'ArrowDown' || event.key === 'ArrowUp' || event.key === 'ArrowLeft' || event.key === 'ArrowRight')
      this.$emit('arrowEvent', {event, component: this, id: this.id, direction : (event.key === 'ArrowDown' || event.key === 'ArrowRight') ? 'next' : 'previous'});
    if(event.key === 'Tab')
      this.$emit('tabEvent', {event, component: this, id: this.id});
  }

  canBeTabbedByKeyboard(){
    if(this.selected || this.multiple)
      return true;
    return !this.haveOptionSelected && this.isFirstOption;
  }

}
